export const basePath = "https://webpersonalcourse1.herokuapp.com/api"; //ya se tiene el path
export const apiVersion = "v1"; //api version
